import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VBtn,_vm._g({attrs:{"text":"","icon":""}},on),[_c(VIcon,{attrs:{"color":"light-grey"}},[_vm._v(_vm._s(`${_vm.icon}`))])],1)]}}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }